module.exports = __webpack_public_path__ + "img/logoradar.300d55cb.png";